import React, { useRef, useState } from 'react';
import { Play, Pause, Volume2, VolumeX } from 'lucide-react';

const VideoPromo = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-black via-zinc-950 to-black relative overflow-hidden">
      {/* Background Glow Effect */}
      <div className="absolute inset-0 bg-gradient-radial from-red-600/10 via-transparent to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Conheça o <span className="text-red-600">Apex Stream</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl max-w-3xl mx-auto">
            Todos os seus streamings favoritos em um só lugar. Netflix, Disney+, HBO Max, Prime Video e muito mais!
          </p>
        </div>

        {/* Video Container */}
        <div className="relative max-w-5xl mx-auto">
          {/* Video Wrapper with Border Glow */}
          <div className="relative rounded-2xl overflow-hidden border-2 border-red-600/30 shadow-2xl shadow-red-600/20 bg-zinc-900">
            {/* Video Element */}
            <video
              ref={videoRef}
              className="w-full h-auto"
              muted={isMuted}
              loop
              playsInline
              poster="https://images.pexels.com/photos/31543214/pexels-photo-31543214.jpeg"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            >
              <source
                src="https://customer-assets.emergentagent.com/job_mediastream-397/artifacts/hs679kuf_Biblioteca%20de%20An%C3%BAncios%20%283%29.mp4"
                type="video/mp4"
              />
              Seu navegador não suporta vídeos HTML5.
            </video>

            {/* Video Overlay Controls */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20 opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <button
                onClick={togglePlay}
                className="bg-red-600 hover:bg-red-700 w-20 h-20 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all"
              >
                {isPlaying ? (
                  <Pause className="w-10 h-10 text-white fill-white" />
                ) : (
                  <Play className="w-10 h-10 text-white fill-white ml-1" />
                )}
              </button>
            </div>

            {/* Mute Button */}
            <button
              onClick={toggleMute}
              className="absolute bottom-4 right-4 bg-black/70 hover:bg-red-600 p-3 rounded-full transition-colors z-20"
            >
              {isMuted ? (
                <VolumeX className="w-5 h-5 text-white" />
              ) : (
                <Volume2 className="w-5 h-5 text-white" />
              )}
            </button>
          </div>

          {/* Features Below Video */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="bg-zinc-900/50 backdrop-blur-sm border border-zinc-800 rounded-lg p-6 text-center hover:border-red-600 transition-all">
              <div className="text-red-600 text-3xl font-black mb-2">25.000+</div>
              <p className="text-gray-300 font-medium">Filmes Disponíveis</p>
            </div>
            <div className="bg-zinc-900/50 backdrop-blur-sm border border-zinc-800 rounded-lg p-6 text-center hover:border-red-600 transition-all">
              <div className="text-red-600 text-3xl font-black mb-2">100+</div>
              <p className="text-gray-300 font-medium">Canais Ao Vivo</p>
            </div>
            <div className="bg-zinc-900/50 backdrop-blur-sm border border-zinc-800 rounded-lg p-6 text-center hover:border-red-600 transition-all">
              <div className="text-red-600 text-3xl font-black mb-2">HD/4K</div>
              <p className="text-gray-300 font-medium">Qualidade Premium</p>
            </div>
          </div>
        </div>

        {/* CTA Button Below */}
        <div className="text-center mt-12">
          <a
            href="https://linkly.link/2WYOm"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-red-600 hover:bg-red-700 text-white font-bold text-lg px-12 py-4 rounded-lg shadow-2xl hover:shadow-red-600/50 transition-all hover:scale-105 inline-flex items-center gap-2"
          >
            <Play className="w-6 h-6 fill-white" />
            Experimente Agora Grátis!
          </a>
        </div>
      </div>
    </section>
  );
};

export default VideoPromo;
